import SideImage from "../../assets/true-agency.png"

const AuthImage = () => (
  <div className="image-overlay">
    <img src={SideImage} className="img-fluid rounded" alt="true-agency" />
  </div>
)

export default AuthImage;